import React, { Component } from 'react';
import Select from 'react-select';

import services from './data';

let CategoryOptions;

class BowserList extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      options: [],
    };
  }
  componentDidMount() {
    services
      .getBowserList()
      .then((response) => {
        let tmp = response.data.data;
        CategoryOptions = [];
        // filter the data if parent product props exists
        if (this.props.parentProduct) {
          tmp = tmp.filter(
            (item) => item.product.uuid === this.props.parentProduct,
          );
        }
        for (let i = 0; i < tmp.length; i++) {
          CategoryOptions.push({
            label: tmp[i].name,
            value: tmp[i].uuid,
          });
        }
        this.setState({ options: CategoryOptions });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  handleChange = (selectedOption) => {
    const val = selectedOption.value;
    const id = this.props.did ? this.props.did : 0;
    this.props.onChange(val, id);
  };

  render() {
    const { options } = this.state;
    return (
      <Select
        onChange={this.handleChange}
        options={options}
        className="select-box-container"
        classNamePrefix="raw-select"
        name="bowsers"
        placeholder="Select Bowser"
        value={options.filter(({ value }) => value === this.props.value)}
      />
    );
  }
}

export { BowserList };
